import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect, useMemo, useState } from 'react';
import { Small } from 'foundations-components/transitional/components/Small';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useGetHoverDateTimeCell, useSetHoverDateTimeCell } from 'framework-listing-lib/internal/FrameworkDataTable/hooks/useInlineEdit';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TooltipContent({
  open,
  value
}) {
  if (!value || !open) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  const portalTz = I18n.moment['portalTz'](parseInt(value, 10)).format('L LT z');
  const localTz = I18n.moment['userTz'](parseInt(value, 10)).format('L LT z');
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "frameworkListingLib.cells.datetime.local"
    }), ":", ' ', localTz, /*#__PURE__*/_jsx("br", {}), portalTz === localTz ? /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.cells.datetime.timezoneMatch"
      })
    }) : /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "frameworkListingLib.cells.datetime.portal"
      }), ": ", portalTz]
    })]
  });
}
export function TimeZoneTooltipWithoutInlineEdit({
  value,
  children
}) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "time-zone-tooltip",
    disabled: !value,
    maxInlineSize: `${300}px`,
    onOpenChange: () => {
      setTooltipOpen(true);
    },
    placement: "top",
    title: /*#__PURE__*/_jsx(TooltipContent, {
      open: tooltipOpen,
      value: value
    }),
    children: children
  });
}
export function TimeZoneTooltipWithInlineEdit({
  children,
  objectId,
  propertyName,
  value
}) {
  const hoverDateTimeCell = useSetHoverDateTimeCell();
  const currentHoverDateTimeCell = useGetHoverDateTimeCell();
  const isOpen = useMemo(() => Boolean(currentHoverDateTimeCell && currentHoverDateTimeCell.objectId === objectId && currentHoverDateTimeCell.propertyName === propertyName), [currentHoverDateTimeCell, objectId, propertyName]);

  /**
   * framework-data-table does not offer a ref to the table cell
   * so we need to inspect on the DOM element to decide whether to show/how the time zone tooltip
   */
  useEffect(() => {
    const tdElement = document.querySelector(`td[data-test-id="framework-data-table-editable-cell"][data-test-object-id="${objectId}"][data-test-property-name="${propertyName}"]`);
    if (!tdElement) {
      return () => {};
    }
    const mouseEnter = () => {
      hoverDateTimeCell(objectId, propertyName);
    };
    const mouseLeave = () => {
      hoverDateTimeCell(null, null);
    };
    tdElement.addEventListener('mouseover', mouseEnter);
    tdElement.addEventListener('mouseleave', mouseLeave);
    // same as mouseleave, this is just to disable the tooltip when entering edit mode
    tdElement.addEventListener('click', mouseLeave);
    return () => {
      tdElement.removeEventListener('mouseover', mouseEnter);
      tdElement.removeEventListener('mouseleave', mouseLeave);
      tdElement.removeEventListener('click', mouseLeave);
    };
  }, [hoverDateTimeCell, objectId, propertyName]);
  return /*#__PURE__*/_jsx(Tooltip, {
    "data-test-id": "time-zone-tooltip",
    disabled: !value,
    maxInlineSize: `${300}px`,
    open: isOpen,
    placement: "top",
    title: /*#__PURE__*/_jsx(TooltipContent, {
      open: isOpen,
      value: value
    }),
    children: children
  });
}